import { mainPageAnimation } from './main-page.animation';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BackgroundPlayerComponent, DwallClickableMediaDirective, InteractionService, WidgetUiConfigRef } from '@core';
import { TabBarComponent } from '@app/components/tab-bar/tab-bar.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-main',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  animations: [
    mainPageAnimation,
  ],
  imports: [
    RouterOutlet,
    TabBarComponent,
    BackgroundPlayerComponent,
    DwallClickableMediaDirective,
  ],
})
export class MainPageComponent {

  public readonly userInteracts = toSignal(this.interaction.status$, {
    initialValue: false,
  });

  constructor(
    private readonly interaction: InteractionService,
    private readonly widgetUiConfig: WidgetUiConfigRef,
  ) {}

  get widgetUi(): WidgetUiConfigRef {
    return this.widgetUiConfig;
  }
}
